import { axiosBase, errorHandler } from './axios';

const fetchAvailability = async (payload: any) => {
  try {
    const resp = await axiosBase.post('/api/v1/availability/get', payload);
    return resp.data;
  } catch (error: any) {
    throw errorHandler(error);
  }
};

const updateAvailability = async (payload: any) => {
  try {
    const resp = await axiosBase.post('/api/v1/availability/update', payload);
    return resp.data;
  } catch (error: any) {
    throw errorHandler(error);
  }
};

export const availabilityService = {
  fetchAvailability,
  updateAvailability,
};
